import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import styles from "./containerList.module.css";
import { useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";

const AddContainer = ({ onSubmit, setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [isFreightOther, setIsFreightOther] = useState(null);
  const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      container_no: "",
      seal_ref_no: "",
      address: "",
      contact_no: "",
      freight: "",
    },
  });

  let { ref: ref1 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address", place.formatted_address);
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: 'UK' },
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("container_no", editData?.container_no);
      setValue("seal_ref_no", editData?.seal_ref_no);
      setValue("address", editData?.address);
      setValue("contact_no", editData?.contact_no);
      if (editData?.freight === "Freight" || editData?.freight === "Bennett McMahon") {
        setValue("freight", editData?.freight);
      } else {
        setIsFreightOther("Other");
        setValue("freight", "Other");
        setValue("freight_other", editData.freight);
      }
    }
  }, [editData, setValue]);

  const onSubmitLocal = (data) => {
    let postData = { seal_ref_no: data?.seal_ref_no, container_no: data?.container_no, freight: data?.freight };
    if (data?.address !== "") {
      postData = { ...postData, address: data?.address };
    }
    if (data?.contact_no !== "") {
      postData = { ...postData, contact_no: data?.contact_no };
    }
    if (data?.freight === "Other") {
      postData = { ...postData, freight: data?.freight_other };
    }

    setLoading(true);
    setFormOpen(false);

    if (editData) {
      axios.put(process.env.REACT_APP_API_URL + "v1/containers/" + editData?.id, postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/containers", postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return [response.data.data].concat(prev);
          });
          onSubmit(response.data.data);
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<form onSubmit={handleSubmit(onSubmitLocal)}>
    <div className={`${styles.FormMainRow}`}>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("seal_ref_no", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Seal Ref No*" variant="outlined" />)}
        />
        {errors.seal_ref_no && (<span className={`ErrorM`}>{errors?.seal_ref_no?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("container_no", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Container Number*" variant="outlined" />)}
        />
        {errors.container_no && (<span className={`ErrorM`}>{errors?.container_no?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("address", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Container Address*" variant="outlined" inputRef={ref1} placeholder="" />)}
        />
        {errors.address && (<span className={`ErrorM`}>{errors?.address?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("contact_no", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Contact Person Number*" variant="outlined" />)}
        />
        {errors.contact_no && (<span className={`ErrorM`}>{errors?.contact_no?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Freight Forwarder*</InputLabel>
          <Controller
            control={control}
            {...register("freight", { required: "This field is Required" })}
            render={({ field }) => (<Select
              {...field}
              label="Freight Forwarder*"
              onChange={(e) => {
                field.onChange(e);
                setIsFreightOther(e.target.value);
              }}
            >
              <MenuItem value="Freight">Freight</MenuItem>
              <MenuItem value="Bennett McMahon">Bennett McMahon</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>)}
          />
        </FormControl>
        {errors.freight && (<span className={`ErrorM`}>{errors?.freight?.message}</span>)}
      </div>
      {isFreightOther === "Other" && (<div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("freight_other", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Other*" variant="outlined" />)}
        />
        {errors.freight_other && (<span className={`ErrorM`}>{errors?.freight_other?.message}</span>)}
      </div>
      )}
    </div>
    <div className="ButtonAction">
      <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
      <Button className="SubmitPopupBU" type="submit">{editData ? "Update" : "Add"}</Button>
    </div>
  </form>);
};

export default AddContainer;